<div fxLayout="row" fxLayoutAlign="center center" fxFlexFill>
  <h1>ACCOUNT SETTINGS</h1>
</div>
